import { PurchasesByProductModel, SpendReportModel, SystemListModel } from "@iewcasia/Types/CustomApiModels";
import { ApiParameter, get, post, request, ServiceResult } from "@insite/client-framework/Services/ApiService";
import { CountryModel } from "@insite/client-framework/Types/ApiModels";

const baseUrl = "/api/v1";

export interface GetSystemListParameters extends ApiParameter {
    namelist: string;
}

export interface GetProductDetailsQuoteListParameters extends ApiParameter {
    id: string;
}

interface SystemListApiModel {
    SystemList: {
        AdditionalInfo?: string;
        Description?: string;
        Name?: string;
    }[];
}

interface SystemListsApiModel {
    SystemListDictionary: {
        [key: string]: SystemListModel[];
    };
}

export interface GenericModalApiParameter extends ApiParameter {
    OrderData?: any;
    email?: string;
    entityId?: string;
    entityName?: string;
    firstName?: string;
    lastName?: string;
    message?: string;
    responseInsite?: string;
    responseSF?: string;
}

export interface DownloadCustomerDocumentApiParameter extends ApiParameter {
    documentId: string;
    type: string;
}

export async function getSystemList(parameter?: GetSystemListParameters): Promise<ServiceResult<any>> {
    const data = await get<SystemListApiModel>(`${baseUrl}/customlist/list`, parameter);

    return {
        successful: true,
        result: {
            systemList: data.SystemList?.map(list => ({
                additionalInfo: list.AdditionalInfo,
                description: list.Description,
                name: list.Name,
            })),
        },
    };
}

export async function getSystemLists(parameter?: GetSystemListParameters): Promise<
    ServiceResult<{
        [key: string]: SystemListModel[];
    }>
> {
    const data = await get<SystemListsApiModel>(`${baseUrl}/customlist/systemLists`, parameter);

    return {
        successful: true,
        result: data.SystemListDictionary,
    };
}

export async function returnRequestApi(body?: GenericModalApiParameter): Promise<ServiceResult<any>> {
    const result = await post<any>(`${baseUrl}/customOrderDataModal/PostReturnRequestDataModal`, body);

    return {
        successful: true,
        result,
    };
}

export async function changeOrderApi(body?: GenericModalApiParameter): Promise<ServiceResult<any>> {
    const result = await post<any>(`${baseUrl}/customOrderDataModal/PostChangeDataModal`, body);

    return {
        successful: true,
        result,
    };
}

export async function placeOrderApi(body?: GenericModalApiParameter): Promise<ServiceResult<any>> {
    const result = await post<any>(`${baseUrl}/customQuoteDataModal/PostPlaceOrderDataModal`, body);

    return {
        successful: true,
        result,
    };
}

export async function requoteApi(body?: GenericModalApiParameter): Promise<ServiceResult<any>> {
    const result = await post<any>(`${baseUrl}/customQuoteDataModal/PostRequoteDataModal`, body);

    return {
        successful: true,
        result,
    };
}

export async function editQuoteApi(body?: GenericModalApiParameter): Promise<ServiceResult<any>> {
    const result = await post<any>(`${baseUrl}/customQuoteDataModal/PostEditDataModal`, body);

    return {
        successful: true,
        result,
    };
}

export async function cancelQuoteApi(body?: GenericModalApiParameter): Promise<ServiceResult<any>> {
    const result = await post<any>(`${baseUrl}/customQuoteDataModal/PostCancelDataModal`, body);

    return {
        successful: true,
        result,
    };
}

export async function downloadCustomerDocument(
    body: DownloadCustomerDocumentApiParameter,
): Promise<ServiceResult<any>> {
    const document = await post<any>(`${baseUrl}/downloadcustomerdocuments/getpdf`, body);

    return {
        successful: true,
        result: document.results,
    };
}

export async function customContactUsForm(emailTo: string, body?: any): Promise<ServiceResult<any>> {
    const result = await request<any>(
        `${baseUrl}/contactusform/sendmail?EmailTo=${emailTo}`,
        "POST",
        { "Content-Type": "application/json" },
        JSON.stringify(body),
    );

    return {
        successful: result.Success,
        result,
    };
}

export async function getSpendReport(year: number): Promise<ServiceResult<SpendReportModel>> {
    const result = await get<SpendReportModel>(`${baseUrl}/spendreport/${year}`);

    return {
        successful: true,
        result,
    };
}

export async function getPurchasedProductsReport(year: number): Promise<ServiceResult<PurchasesByProductModel>> {
    // const result = await get<PurchasesByProductModel>(`${baseUrl}/spendreportbycategory/chartdata/${year}`);
    const result = await get<PurchasesByProductModel>(`${baseUrl}/spendreportbycategory/chartdatav2/${year}`);

    return {
        successful: true,
        result,
    };
}

export function getCustomCountries(): Promise<CountryModel[]> {
    return get<CountryModel[]>(`${baseUrl}/CustomCountries/countries`);
}

export async function getProductDetailQuoteListing(
    parameter?: GetProductDetailsQuoteListParameters,
): Promise<ServiceResult<any>> {
    const encodedProductNumber = encodeURIComponent(parameter?.id || "");
    const result = await get<any>(
        `${baseUrl}/customQuotes/quotesByProductNumber?productNumber=${encodedProductNumber}`,
    );

    return {
        successful: true,
        result,
    };
}

export function getWebsiteLanguages(parameter?: any): Promise<any> {
    return get<any>(`${baseUrl}/customwebsite/languages/${parameter?.websiteId}`);
}
